import {
  useState,
  useEffect,
  // useMemo
} from 'react';
import { useNavigate } from 'react-router-dom';

// UTILITY
import { routeEnhance } from '@/utility/routes';

export default function useRouterLock(allowedRoutes, onBlock, disabled) {
  const [path, setPath] = useState(null);
  const navigate = useNavigate();
  // const enhancedRoutes = useMemo(() => allowedRoutes?.map(routeEnhance), [allowedRoutes]);

  const lockRouter = () => {
    setPath(null);
    // history.block(location => {
    //   setPath(routeEnhance(location.pathname));
    //
    //   if (enhancedRoutes?.some(({ pathname }) => pathname === location.pathname)) {
    //     return true;
    //   }
    //
    //   onBlock();
    //   return false;
    // });
  };

  const routeTo = route => {
    if (!route) {
      return;
    }

    navigate(routeEnhance(route));
  };

  const routeToLast = () => {
    if (!path) {
      return;
    }

    navigate(path);
  };

  useEffect(() => {
    if (disabled) {
      return;
    }

    return lockRouter();
  }, [disabled]);

  return { path, lockRouter, routeTo, routeToLast };
}
